module.exports = require('../_components/@alicd/next-form/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./~/@alicd/next/lib/form/index.js
// module id = 110
// module chunks = 0